import React from "react"
import PropTypes from "prop-types"
import verified from "assets/images/other/verified.png"
import downloadBanner from "assets/images/other/form.svg"
import moment from "moment"

const ChallanReceiptContent = React.forwardRef(({ challanData }, ref) => {
  const receivedDateFormatted = () => {
    return challanData?.recieved_on
      ? moment(challanData.recieved_on).format("DD/MM/YYYY")
      : "---"
  }

  return (
    <div
      ref={ref}
      className="p-3 pb-0"
      style={{
        width: "100%",
        fontFamily: "Poppins, sans-serif",
        paddingBottom: "6px",
      }}
    >
      <img
        src={downloadBanner}
        alt="Focus Motors Banner"
        style={{ maxWidth: "100%",width:'100%', height: "auto", marginBottom: "20px" }}
      />
      <div className="receipt-box px-4">
        <h5
          className="text-center "
          style={{
            fontSize: "16px",
            color: "black",
            fontWeight: 500,
            marginBottom: "30px",
          }}
        >
          Payment Receipt
        </h5>
        <div style={{ maxWidth: "310px", margin: "0 auto" }}>
          <div className="receipt-field mb-2 d-flex justify-content-between">
            <span className="receipt-label">Challan ID :</span>
            <span className="receipt-value">
              {challanData?.challan_id || "---"}
            </span>
          </div>

          <div className="receipt-field mb-2 d-flex justify-content-between">
            <span className="receipt-label">Received From :</span>
            <span className="receipt-value">
              {challanData?.name} {challanData?.phone || "---"}
            </span>
          </div>
          <div className="receipt-field mb-2 d-flex justify-content-between">
            <span className="receipt-label">Description :</span>
            <span className="receipt-value">
              {challanData?.description || "---"}
            </span>
          </div>
          <div className="receipt-field mb-2 d-flex justify-content-between">
            <span className="receipt-label">Amount :</span>
            <span
              className="receipt-value fw-bold"
              style={{ color: "#000000" }}
            >
              ₹ {challanData.amount}
            </span>
          </div>
          <div className="receipt-field mb-2 d-flex justify-content-between">
            <span className="receipt-label">Received On :</span>
            <span className="receipt-value">{receivedDateFormatted()}</span>
          </div>
          <div className="receipt-field d-flex mb-2 justify-content-between">
            <span className="receipt-label">Reference ID :</span>
            <span className="receipt-value">
              {challanData?.reference_id || "---"}
            </span>
          </div>
           <div className="receipt-field  d-flex justify-content-between">
            <span className="receipt-label">Description :</span>
            <span className="receipt-value">
              {challanData?.description || "---"}
            </span>
          </div>
        </div>
        <div
          className="d-flex justify-content-end my-3"
          style={{marginRight: "-10px" }}
        >
          <img
            src={verified}
            alt="verified"
            style={{ maxWidth: "95px", height: "95px", objectFit: "contain" }}
          />
        </div>
      </div>
    </div>
  )
})

ChallanReceiptContent.displayName = "ChallanReceiptContent"

ChallanReceiptContent.propTypes = {
  challanData: PropTypes.any,
}

export default ChallanReceiptContent
